import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import MandatEmisApresPaiementComponent from '../../../../components/Mouvement/Panel/InformationsRattachement/MandatEmisApresPaiementComponent';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class MandatEmisApresPaiementPanel extends InformationsRattachementPanel {
	// Le bloc ne saisit que l'exercice de rattachement et la pièce d'origine.
	isComplete = (data: Mouvement) =>
		this.isCompleteFor(data, 'exerRattachement', 'pieceOrigine');

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<MandatEmisApresPaiementComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default MandatEmisApresPaiementPanel;
